
import {MdOutlineMoreHoriz} from "react-icons/md"

import styled from "styled-components"
import formatConverter from "../../../../helper/formatConverter"
import { formatShipmentDate, getShipmentRouteBounds, normalizeShipmentListItem } from "../../../../helper/shipment/safeShipmentListItem"
import { useState, useEffect} from "react"
import { useDispatch } from "react-redux"
import { useSelector } from "react-redux"
import moment from "moment"
import { setSelectUserData } from "../../../../features/user/userSlice"
import { showNestedModal } from "../../../../features/modal/modalSlice"
import { setTopPagesItemNotificationClicked } from "../../../../features/loadList/loadListSlice"
import CopyableShipmentValue from "../../../shipmentOperation/CopyableShipmentValue"
import { compactShipmentCardStyles } from "../../../shipmentOperation/shipmentCardStyles"
import ShipmentSelectionCheckbox from "../../shared/ShipmentSelectionCheckbox"

const Container = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-bottom: 40px;
    color: ${({theme}) => theme.mainTextColor};
    cursor: pointer;

    .titles-container{
        width: 100%;
        display: flex;
        justify-content: space-between;
        margin-bottom: 5px;
        padding-left: 40px;
        padding-right: 20px;

        .title-item{
            width: 15%;
            font-size: var(--font-size-sm);
            font-weight: var(--font-weight-lg);

        }
    }

    .content-container{
        width: 100%;
        display: flex;
        flex-direction: column;
        background-color: ${({theme, isNotificationed}) => isNotificationed ? "#e854461d" :theme.secondaryBgColor};
        ${({ border }) => border && `animation: blinkBorder 3s step-end 3`};
        border-radius: 10px;
        padding: 20px 20px 20px 40px;
        border: 2px solid transparent;
        position: relative;
    padding-bottom: 20px;

                    .absolute-id{
            position: absolute;
            bottom: 0;
            left: 0;
            border: 1px solid var(--color-main);
            border-radius: 4px;
            border-bottom-left-radius: 10px;
            padding: 3px;
            font-size: 14px;
            width: 70px;
            text-align: center;
            font-weight: var(--font-weight-lg);
            background-color: var(--color-main);
            color:#fff;
        }

        .content-wrapper{
            width: 100%;
            display: flex;
            justify-content: space-between;
            margin-bottom: 30px;

            .content-column{
                width: 15%;
                display: flex;
                flex-direction: column;
                gap: 5px;

                .content-item{
                    font-size: var(--font-size-sm);
                    font-weight: var(--font-weight-md);
                }
            }
        }

        .route-wrapper{
            width: 100%;
            display: flex;
            justify-content: center;
        }
    }

    @keyframes blinkBorder {
    0% {
      border-color: transparent;
    }
    25% {
      border-color: var(--color-main);
    }
    50% {
      border-color: transparent;
    }
    75% {
      border-color: var(--color-main);
    }
    100% {
      border-color: transparent;
    }
  }

  ${compactShipmentCardStyles}
`

const Ccontainer = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;

    .route-item{
        display: flex;
        align-items: center;

        .point{
         position: relative;
         display: flex;
         align-items: center;

         .text{
            position: absolute;
            left: 50%;
            top: -70%;
            transform: translate(-50%, -50%);
            font-size: var(--font-size-sm);
            font-weight: var(--font-weight-xl);
            color: ${({theme}) => theme.mainTextColor};
         }

         .active-text{
            color: var(--color-main);
         }
        }

        .line{
            width: 260px;
            border-top: 1px dashed ${({theme}) => theme.mainTextColor};
            z-index: 5;
        }

        .yellow{
            border-color: var(--color-main);
        }

    }



`


const Routeline = ({order}) => {

    const {theme} = useSelector(state => state.layout)

    const list = [
        {
            id: 1,
            text: "Yüklemede",
        },
        {
            id: 2,
            text: "Seferde",
        },
        {
            id: 3,
            text: "Boşaltmada",
        },
        {
            id: 4,
            text: "Tamamlandı",
        }

    ]

    return (
        <Ccontainer>
            {
                list.map((item, i)=> (
                            <div className="route-item" key={i}>
                                <div className="point">
                                    <div className={item.id <= order ? "active-text text" : "text"}>{item.text}</div>
                                    <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="7.5" cy="7.5" r="7" transform="matrix(-1 0 0 1 15 0)" fill={item.id  <= order ? "#E85446" : "transparent"} stroke={item.id  <= order ? "#E85446" : theme === "dark" ?  "#b8b4b4" : "#3C3C3B"}/>
                                    </svg>
                                </div>
                                {
                                    list.length !== i+1 &&
                                    <div className={"line"}/>
                                }
                            </div>
                    )
                )
            }
        </Ccontainer>
    )
}

const ItemContainer = ({item: sourceItem, setActiveItemId, isSelected, onSelectionChange, notificationType = 3, notificationStageType = "yukleme"}) => {
    const item = normalizeShipmentListItem(sourceItem)
    const { firstRoutePoint, lastRoutePoint } = getShipmentRouteBounds(item.routePoints)

    const titles = ["Sürücü ve Araç", "Yükleme", "Boşaltma", "Yük", "Diğer Bilgiler"]    
    const {loadItemSelect} = useSelector(state => state.loadList)

    const storage = JSON.parse(localStorage.getItem("isRemember")) ? localStorage : sessionStorage;
    const rld = JSON.parse(storage.getItem("rld"))

    const dispatch = useDispatch()


  return (
    <Container id={item.id} onClick={() => {window.getSelection().toString().length < 1 && setActiveItemId(item.id); item.waitinLoad.notificationType === notificationType && dispatch(setTopPagesItemNotificationClicked({type: notificationStageType, id: item.id}))}}  border={item.waitinLoadId === loadItemSelect} isNotificationed={item.waitinLoad.notificationType === notificationType}>
        <div className="titles-container">
            {
                titles.map((item, i) => (
                    <div className="title-item" key={i}>{item}</div>
                ))
            }
        </div>

        <div className="content-container">
            <ShipmentSelectionCheckbox checked={isSelected} onChange={onSelectionChange} shipmentId={item.id} />
            <CopyableShipmentValue className="absolute-id" label="ID" value={item.id} />

            <div className="content-wrapper">
                <div className="content-column">
                    <div onClick={(e) => { e.stopPropagation(); dispatch(showNestedModal("surucuProfil")); dispatch(setSelectUserData(item?.driverPhoneNumber)) }} className="content-item driver">{item?.driverName}</div>
                    <div className="content-item">{item?.driverPhoneNumber}</div>
                     <div className="content-item">{item.truckPlateNumber} - {item.truckType}</div>
                    <div className="content-item">{item.trailerPlateNumber} - {item.trailerType} </div>
                </div>

                <div className="content-column">
                    <div className="content-item">{formatShipmentDate(firstRoutePoint.loadDate, value => moment(value).format("DD.MM.YYYY"))}</div>
                    <div className="content-item">{firstRoutePoint.loadTime} {firstRoutePoint.lateLoadTime}</div>
                    <div className="content-item">{firstRoutePoint.location}</div>
                    <div className="content-item">{firstRoutePoint.displayName}</div>
                </div>

                <div className="content-column">
                <div className="content-item">{formatShipmentDate(lastRoutePoint.loadDate, value => moment(value).format("DD.MM.YYYY"))}</div>
                    <div className="content-item">{lastRoutePoint.loadTime} {lastRoutePoint.lateLoadTime}</div>
                    <div className="content-item">{lastRoutePoint.location}</div>
                    <div className="content-item">{lastRoutePoint.displayName}</div>
                </div>

                <div className="content-column">
                    <div className="content-item">{item.isParsiyel ? "LTL(Parsiyel)" : "FTL(Komple Araç)"}</div>
                    {
                            item.loadUnit === "BASAR TONAJ" ? 
                            <div className="content-item">Basar Tonaj {((item.itemBulk > 0) &&` - ${item.itemBulk}`)}</div>
                            :
                            <div className="content-item">{item.loadUnit === "BASAR TONAJ" ? "Basar Tonaj": `${item.loadQuantity} ${item.loadUnit}`}</div>
                        }
                    <div className="content-item">{item.loadType}</div>
                </div>

                <div className="content-column">
                    <CopyableShipmentValue className="copy-field" label="Konteyner No" value={item.containerNumber} />
                    <CopyableShipmentValue className="copy-field" label="Mühür No" value={item.sealNumber} />
                    <CopyableShipmentValue className="copy-field" label="Firma Sevk. No" value={item.companyLoadNumber} />
                </div>
            </div>
            <div className="route-wrapper">
            <Routeline order={1}/>
            </div>
        </div>
      
    </Container>
  )
}

export default ItemContainer
